
import { RevButton } from '@ds/components/Button'

import translations from './PDFLink.translations'

export default {
  components: {
    RevButton,
  },
  props: {
    url: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },

  computed: {
    translations: () => translations,
    alternativeLabel() {
      return `${this.title} ${this.$t(this.translations.pdfLink)}`
    },
  },
}
